import React from "react";

const Notification = ({ notification, onClose }) => {
  if (!notification) return null;

  return (
    <>
      <div className={`notification-toast ${notification.type}`}>
        <div className="notification-icon">
          {notification.type === "success" ? (
            <svg viewBox="0 0 24 24" width="24" height="24">
              <path
                fill="currentColor"
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
              />
            </svg>
          ) : notification.type === "warning" ? (
            <svg viewBox="0 0 24 24" width="24" height="24">
              <path
                fill="currentColor"
                d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
              />
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" width="24" height="24">
              <path
                fill="currentColor"
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
              />
            </svg>
          )}
        </div>
        <span className="notification-message">{notification.message}</span>
        <button className="notification-close" onClick={onClose}>
          ✕
        </button>
      </div>

      <style jsx="true">{`
        .notification-toast {
          position: fixed;
          top: 20px;
          right: 20px;
          z-index: 2000;
          background-color: white;
          padding: 16px 20px;
          border-radius: 12px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
          display: flex;
          align-items: center;
          gap: 12px;
          min-width: 300px;
          max-width: 400px;
          animation: slideInRight 0.3s ease-out;
        }

        .notification-toast.success {
          border-left: 4px solid #4caf50;
        }

        .notification-toast.error {
          border-left: 4px solid #f44336;
        }

        .notification-toast.warning {
          border-left: 4px solid #ff9800;
        }

        @keyframes slideInRight {
          from {
            opacity: 0;
            transform: translateX(100%);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        .notification-icon {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .notification-toast.success .notification-icon {
          color: #4caf50;
        }

        .notification-toast.error .notification-icon {
          color: #f44336;
        }

        .notification-toast.warning .notification-icon {
          color: #ff9800;
        }

        .notification-message {
          flex: 1;
          font-size: 15px;
          color: #333;
          font-weight: 500;
        }

        .notification-close {
          flex-shrink: 0;
          background: none;
          border: none;
          font-size: 20px;
          color: #999;
          cursor: pointer;
          padding: 4px;
          border-radius: 4px;
          transition: all 0.2s;
          line-height: 1;
        }

        .notification-close:hover {
          background-color: #f5f5f5;
          color: #333;
        }

        /* Mobil için */
        @media (max-width: 768px) {
          .notification-toast {
            top: 10px;
            right: 10px;
            left: 10px;
            min-width: auto;
            max-width: none;
            padding: 14px 16px;
          }

          .notification-message {
            font-size: 14px;
          }
        }

        @media (max-width: 480px) {
          .notification-toast {
            padding: 12px 14px;
            gap: 10px;
          }

          .notification-icon svg {
            width: 20px;
            height: 20px;
          }

          .notification-message {
            font-size: 13px;
          }

          .notification-close {
            font-size: 18px;
          }
        }
      `}</style>
    </>
  );
};

export default Notification;
